import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useSharedMembers = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['shared-members', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('shared_members')
        .select(`
          id,
          user_id,
          primary_household_id,
          linked_household_id,
          profiles(id, display_name, avatar_url, member_color)
        `)
        .or(`primary_household_id.eq.${household.id},linked_household_id.eq.${household.id}`)
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => {
    qc.invalidateQueries({ queryKey: key })
    qc.invalidateQueries({ queryKey: ['members', household?.id] })
  }

  // Children this household has shared OUT (primary = this household)
  const sharedOut = (query.data ?? []).filter((s) => s.primary_household_id === household?.id)
  // Children received FROM linked household
  const sharedIn  = (query.data ?? []).filter((s) => s.linked_household_id === household?.id)

  const isSharedOut = (userId) => sharedOut.some((s) => s.user_id === userId)

  const toggleShare = async (userId, linkedHouseholdId) => {
    if (isSharedOut(userId)) {
      const { error } = await supabase
        .from('shared_members')
        .delete()
        .eq('user_id', userId)
        .eq('primary_household_id', household.id)
      if (error) throw error
    } else {
      const { error } = await supabase
        .from('shared_members')
        .insert({
          user_id:              userId,
          primary_household_id: household.id,
          linked_household_id:  linkedHouseholdId,
          created_by:           user.id,
        })
      if (error) throw error
    }
    inv()
  }

  return { ...query, sharedOut, sharedIn, isSharedOut, toggleShare }
}
